import React, { useState } from 'react';
import {
  useResponsiveParams,
  Text,
  useQuantaFormikContext,
  MixedGridGroup,
  QuantaForm,
  Button,
} from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faExclamationTriangle,
  faSearch,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import {
  CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
  PINCODE_LOOKUP,
  VERIFY_CRN_NUMBER,
} from '../../queries';
import { NotificationList } from 'quanta-ui';
import {useFetchQuery} from 'quanta-flows';
import { useQuery } from '@apollo/client';
import {Loading} from 'quanta-flows/modules/layout';
import moment from 'moment';

export default function IndividualCustomerForm({
  setIndvCustomerDomainArr,
  buyHealthPolicy,
  isConfigImd
}) {
  const { values, setFieldValue } = useQuantaFormikContext();
  const [alerts, setAlerts] = useState([]);
  const [loadingPermCustAddr, setLoadingPermCustAddr] =
    useState(false);
  const [loadingCommCustAddr, setLoadingCommCustAddr] =
    useState(false);
    const [CRNVerified, setCRNVerified] = useState(
      buyHealthPolicy?.proposerDetailsMeta?.isCRNVerified === "" ?
      null : buyHealthPolicy?.proposerDetailsMeta?.isCRNVerified 
    );
    const [loadingVerifyCRN, setLoadingCRN] =useState(false);
    const [KotakBankCrnSelected, setKotakBankCrnSelected] =useState(
      buyHealthPolicy?.proposerDetailsMeta?.ciuType?.toString() === 'Kotak Bank CRN Number'
      ? true :
      buyHealthPolicy?.proposerDetailsMeta?.ciuType?.toString() == ''
      ? true: false
    );
  const reformData = (val, returnType) => {
    return val && val.toString().trim() !== '' ? val : returnType;
  };
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.toLowerCase() ===
        searchText?.toString()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.toLowerCase() ===
            searchText?.toString()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const fetchQuery = useFetchQuery();


  const { loading, data: dropDownDetails } = useQuery(
    CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
    {
      fetchPolicy: 'cache-first',
      onCompleted: (data) => {
        setIndvCustomerDomainArr(data);
        if(!values?.proposerDetails?.eiaRequired){
          setFieldValue( `proposerDetails.eiaRequired`, 'No' ,);
        }
        if(isConfigImd && !values?.proposerDetails?.ciuType){
          setFieldValue(`proposerDetailsMeta.ciuType`,'Other Bank CRN');
          setKotakBankCrnSelected(false);
        }
      },
      onError: (err) => {
        setAlerts([
          {
            header: 'No dropdown details',
            id: 1,
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{err.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
  );

  let repeat = useResponsiveParams({ for_mobile: 1, for_desktop: 3 });

  const onPermAddrLookup = async (val, setFieldValue) => {
    if (
      !(
        val.toString().length !== 6 ||
        !val.toString().match(/^[0-9]+$/)
      )
    ) {
      let queryOutput = fetchQuery({
        query: PINCODE_LOOKUP,
        variables: {
          filter: {
          pincode: val,
          },
        },
      });
      try {
        setAlerts([]);
        setLoadingPermCustAddr(true);
        let { data } = await queryOutput;
        setLoadingPermCustAddr(false);
        setFieldValue(
          'proposerDetails.permCityTownVillage',
          data.pincodeInfo.city,
        );
        setFieldValue(
          'proposerDetails.permDistrict',
          data.pincodeInfo.district,
        );
        setFieldValue(
          'proposerDetails.permState',
          data.pincodeInfo.state,
        );
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue(
            'proposerDetails.commCityTownVillage',
            data.pincodeInfo.city,
          );
          setFieldValue(
            'proposerDetails.commDistrict',
            data.pincodeInfo.district,
          );
          setFieldValue(
            'proposerDetails.commState',
            data.pincodeInfo.state,
          );
        }
      } catch (error) {
        setAlerts([
          {
            header: 'Address fetch failed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{error.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingPermCustAddr(false);
        setFieldValue('proposerDetails.permCityTownVillage', '');
        setFieldValue('proposerDetails.permDistrict', '');
        setFieldValue('proposerDetails.permState', '');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const onCommAddrLookup = async (val, setFieldValue) => {
    if (
      !(
        val.toString().length !== 6 ||
        !val.toString().match(/^[0-9]+$/)
      )
    ) {
      let queryOutput = fetchQuery({
        query: PINCODE_LOOKUP,
        variables: {
          filter: {
          pincode: val,
          },
        },
      });
      try {
        setAlerts([]);
        setLoadingCommCustAddr(true);
        let { data } = await queryOutput;
        setLoadingCommCustAddr(false);
        setFieldValue(
          'proposerDetails.commCityTownVillage',
          data.pincodeInfo.city,
        );
        setFieldValue(
          'proposerDetails.commDistrict',
          data.pincodeInfo.district,
        );
        setFieldValue(
          'proposerDetails.commState',
          data.pincodeInfo.state,
        );
      } catch (error) {
        setAlerts([
          {
            header: 'Address fetch failed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{error.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingCommCustAddr(false);
        setFieldValue('proposerDetails.commCityTownVillage', '');
        setFieldValue('proposerDetails.commDistrict', '');
        setFieldValue('proposerDetails.commState', '');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }

  const {
    salutationList,
    genderList,
    idProofTypeList,
    maritalStatusList,
    nationalityList,
    occupationList,
    eiaRequired,
    ciuTypeList,
  } = dropDownDetails;

  const data = [
    buyHealthPolicy?.proposerDetails?.id
      ? {
          title: (
            <span className="text-primary break-all">
              {[
                buyHealthPolicy?.proposerDetails?.title,
                buyHealthPolicy?.proposerDetails?.fullName,
              ]
                .filter((n) => n)
                .join(' ')}
              {','}
              {repeat === 1 ? <br /> : <>&nbsp;</>}
              {buyHealthPolicy?.proposerDetails.id}{' '}
              <span className="break-normal">
                - Update or confirm details
              </span>
            </span>
          ),
          grid_type: 'data',
          grid_data: [
            {
              label: 'Customer Number',
              text: reformData(
                buyHealthPolicy?.proposerDetails?.id,
                '',
              ),
            },
            // {
            //   label: 'CRN',
            //   text: reformData(
            //     buyHealthPolicy?.proposerDetailsMeta?.crn,
            //     '',
            //   ),
            // },
          ],
        }
      : null,
      {
        title:'',
        grid_type:'input',
        grid_data:[
          {
            type:'select',
            label:  (sessionStorage?.getItem('roleName')?.toString()?.toLowerCase()  === 'bancassurance' || 
            sessionStorage?.getItem('roleName')?.toString()?.toLowerCase()  === 'corporate agent'
            || isConfigImd)  
            ?(
              <div>
                CIU Type <Text severity="error">*</Text>
              </div>
            ) :
            (
              <div> CIU Type </div>
            ),
            name: 'proposerDetailsMeta.ciuType',
            data:  ciuTypeList && ciuTypeList?.length > 0 
            ? [
              ...ciuTypeList?.map((data) => {
                return {
                  label : data.code,
                  value: data.value,
                }
              })
            ]
            : [],
            onDataChange:(val,setFieldValue)=>{
              setFieldValue(`proposerDetailsMeta.ciuType`,val);
              setFieldValue(`proposerDetailsMeta.crn`,'');
              setCRNVerified(null);
              if( val === 'Kotak Bank CRN Number'){
                setKotakBankCrnSelected(true);
              }
              else{
                setKotakBankCrnSelected(false);
              }
            },
           disabled: buyHealthPolicy?.proposalNumber.length > 0 ,//reactiveVarData?.proposalNumber.length > 0,
          },
          {
            type: 'text',
            label:  (sessionStorage?.getItem('roleName')?.toString()?.toLowerCase()  === 'bancassurance' || 
             sessionStorage?.getItem('roleName')?.toString()?.toLowerCase()  === 'corporate agent'
             || isConfigImd) 
             ? (
              <div>
                CRN Number <Text severity="error">*</Text>
              </div>
            ) : ( 
                  <div> CRN Number</div>
            ),
            maxlength: 25 ,
            name: 'proposerDetailsMeta.crn',
            onDataChange: (val, _) => {
              setCRNVerified(null);
            },
           disabled: buyHealthPolicy?.proposalNumber.length > 0 ,// reactiveVarData?.proposalNumber.length > 0,
          },
          {
            type: 'render',
            component : () => 
            CRNVerified ? (
              <Text
                className="mt-8 w-28 h-11 flex justify-end items-center -ml-2"
                severity="success"
                type="large"
              >
                <FontAwesomeIcon icon={faCheck} className="mr-2" />
                <Text type="title">Verified</Text>
              </Text>
            ) :
            (
              <Button
                type="button"
                size="small"
                className="mt-8 w-40 h-11 flex justify-end"
                //disabled = {!KotakBankCrnSelected || reactiveVarData?.proposalNumber.length > 0 } 
                disabled = {!KotakBankCrnSelected || buyHealthPolicy?.proposalNumber?.length > 0}
                onClick={async (_)=>{
                  
                  if(values?.proposerDetailsMeta?.crn &&
                    values?.proposerDetailsMeta?.crn?.length > 0
                    && values?.proposerDetailsMeta?.ciuType === 'Kotak Bank CRN Number'){
                      
                        try{  
                          let verifycrnNumber = fetchQuery({
                            query: VERIFY_CRN_NUMBER,
                            variables: {
                              crnNumber:
                                values?.proposerDetailsMeta?.crn,
                            },
                          });
                          setAlerts([]);
                          setLoadingCRN(true);
                          //setLoadingTransaction(true);
                          let { data: verificationData } =
                              await verifycrnNumber;
                         
                          setLoadingCRN(false);
                          if (verificationData.verifyCRNNumber.isVerified)
                          {
                            setCRNVerified(true);
                            setFieldValue(`proposerDetailsMeta.isCRNVerified`,true,);
                          }else {
                            setCRNVerified(false);
                            setFieldValue(`proposerDetailsMeta.isCRNVerified`,false,);
                            setAlerts([
                              {
                                header: 'Transaction ID verification failure',
                                id: Date.now(),
                                content: (
                                  <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                    <span>
                                    Please check the CRN Number entered, either CRN is not valid or is not KYC Compliant or not authorize for insurance transaction.
                                    </span>
                                  </div>
                                ),
                                type: 'error',
                                timeout: null,
                                disableClose: false,
                              },
                            ]);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }                          
                        }catch (error) {
                          setCRNVerified(false);
                          setLoadingCRN(false);
                          setFieldValue(`proposerDetailsMeta.isCRNVerified`,false,);
                            setAlerts([
                              {
                                header: 'Transaction ID verification failure',
                                id: Date.now(),
                                content: (
                                  <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                    <span>
                                    Please check the CRN Number entered, either CRN is not valid or is not KYC Compliant or not authorize for insurance transaction.
                                    </span>
                                  </div>
                                ),
                                type: 'error',
                                timeout: null,
                                disableClose: false,
                              },
                            ]);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                    }
                }}
                flat={true}
                //CRNVerified,loadingVerifyCRN
                iconPre={
                  <div className="text-base">
                    {loadingVerifyCRN ? (
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin={true}
                        className={`${'mx-2'}`}
                      />
                    ) : CRNVerified === false ? (
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        className={'mx-2'}
                      />
                    ) : CRNVerified ? (
                      <FontAwesomeIcon
                        icon={faCheck}
                        className={'mx-2'}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faSearch}
                        className={'mx-2'}
                      />
                    )}
                  </div>
                }
              >
                {loadingVerifyCRN ? (
              <span className="text-base">Verifying</span>
            ) : CRNVerified === false ? (
              <span className="text-base">Not Verified</span>
            ) : CRNVerified ? (
              <span className="text-base">Verified</span>
            ) : (
              <span className="text-base">Verify</span>
            )}
              </Button>
            ),
          }
          
        ],
      },
    {
      title: <span className="text-primary">Personal Details</span>,
      grid_type: 'input',
      grid_data: [
        {
          type: 'select',
          label: (
            <div>
              Title <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.title',
          searchable: true,
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          data: salutationList
            ? [
                ...salutationList.map((title) => {
                  return {
                    label: title.value ? title.value : '',
                    value: title.code ? title.code : '',
                  };
                }),
              ]
            : [],
        },
        {
          type: 'select',
          label: (
            <div>
              Gender <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.gender',
          data: genderList
            ? [
                ...genderList.map((gender) => {
                  return {
                    label: gender.value ? gender.value : '',
                    value: gender.code ? gender.code : '',
                  };
                }),
              ]
            : [],
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'date',
          maxdate: moment()
            .subtract(18, 'years')
            .subtract(1, 'days')
            .format('DD/MM/YYYY'),
          label: (
            <div>
              Date Of Birth <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.proposerDOB',
         // disabled: buyHealthPolicy?.proposalNumber.length > 0,
          disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
        },
        {
          type: 'text',
          label: (
            <div>
              First Name <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.firstName',
         // disabled: buyHealthPolicy?.proposalNumber.length > 0,
         disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
          onDataChange: (val, setFieldValue) => {
            setFieldValue(
              `proposerDetails.fullName`,
              // [
              //   val?.trim(),
              //   values?.proposerDetails?.middleName?.trim(),
              //   values?.proposerDetails?.lastName?.trim(),
              // ]
              //   .filter((n) => n)
              //   .join(' '),
             values?.proposerDetails?.middleName
              ? `${values?.proposerDetails?.firstName} ${values?.proposerDetails?.middleName} ${values?.proposerDetails?.lastName}`
              : values?.proposerDetails?.lastName
                ? `${values?.proposerDetails?.firstName} ${values?.proposerDetails?.lastName}`
                : values?.proposerDetails?.firstName,
            );
          },
        },
        {
          type: 'text',
          label: (
            <div>
              Middle Name <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.middleName',
         //disabled: buyHealthPolicy?.proposalNumber.length > 0,
          disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
          onDataChange: (val, setFieldValue) => {
            setFieldValue(
              `proposerDetails.fullName`,
              // [
              //   values?.proposerDetails?.firstName?.trim(),
              //   val?.trim(),
              //   values?.proposerDetails?.lastName?.trim(),
              // ]
              //   .filter((n) => n)
              //   .join(' '),
              values?.proposerDetails?.middleName
              ? `${values?.proposerDetails?.firstName} ${values?.proposerDetails?.middleName} ${values?.proposerDetails?.lastName}`
              : values?.proposerDetails?.lastName
                ? `${values?.proposerDetails?.firstName} ${values?.proposerDetails?.lastName}`
                : values?.proposerDetails?.firstName,
            );
          },
        },
        {
          type: 'text',
          label: (
            <div>
              Last Name <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.lastName',
          //disabled: buyHealthPolicy?.proposalNumber.length > 0,
          disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
          onDataChange: (val, setFieldValue) => {
            setFieldValue(
              `proposerDetails.fullName`,
              // [
              //   values?.proposerDetails?.firstName?.trim(),
              //   values?.proposerDetails?.middleName?.trim(),
              //   val?.trim(),
              // ]
              //   .filter((n) => n)
              //   .join(' '),
              values?.proposerDetails?.middleName
              ? `${values?.proposerDetails?.firstName} ${values?.proposerDetails?.middleName} ${values?.proposerDetails?.lastName}`
              : values?.proposerDetails?.lastName
                ? `${values?.proposerDetails?.firstName} ${values?.proposerDetails?.lastName}`
                : values?.proposerDetails?.firstName,
            );
          },
        },
        {
          type: 'select',
          label: (
            <div>
              Marital Status <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.maritalStatus',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          data: maritalStatusList
            ? [
                ...maritalStatusList.map((maritalStatus) => {
                  return {
                    label: maritalStatus.value
                      ? maritalStatus.value
                      : '',
                    value: maritalStatus.code
                      ? maritalStatus.code
                      : '',
                  };
                }),
              ]
            : [],
        },
        {
          type: 'select',
          label: (
            <div>
              Nationality <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.nationality',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          data: nationalityList
            ? [
                ...nationalityList.map((nationality) => {
                  return {
                    label: nationality.value ? nationality.value : '',
                    value: nationality.code ? nationality.code : '',
                  };
                }),
              ]
            : [],
        },
        {
          type: 'select',
          label: ( 
            <div>
              Occupation <Text severity="error">*</Text>
            </div>
          ),
          data: occupationList
            ? [
                ...occupationList.map((occupation) => {
                  return {
                    label: occupation.value
                      ? occupation.value
                      : '',
                    value: occupation.code
                      ? occupation.code
                      : '',
                  };
                }),
              ]
            : [],
          name: `proposerDetails.occupation`,
         /// disabled: buyHealthPolicy?.proposalNumber.length > 0,
          onDataChange: (val, setFieldValue) => {
            setFieldValue(
              `proposerDetails.otherOccupation`,
              '',
            );
          },
        },
        {
          type: 'text',
          maxLength: 100,
          disabled:
            values.proposerDetails.occupation !==
              getDomainData(
                occupationList,
                'Others',
                'value',
                'code',
              ), //|| buyHealthPolicy?.proposalNumber.length > 0,
          label: (
            <div>
              If Others Occupation, please specify
            </div>
          ),
          name: `proposerDetails.otherOccupation`,
        },
		/*SADivya - CR P2_233 -KYC*/
        {
          type: 'text',
          label: (
            <div>
              Mother's Maiden Name
            </div>
          ),
          maxLength: 30,
          name: 'proposerDetails.motherMaidenName',
          disabled:buyHealthPolicy?.proposalNumber.length > 0 ,
          onKeyDown: (evt) => {
            if (
              (evt?.target?.value?.toString()?.endsWith(' ') &&
                evt?.key === ' ') ||
              (evt?.target?.value?.toString()?.length === 0 &&
                evt?.key === ' ')
            ) {
              evt.preventDefault();
            }
          },
        },
        {
          type: 'text',
          label: <div>CKYC ID Number</div>,
          maxLength: 14,
          name: 'proposerDetails.ckycIdNumber',
          disabled:buyHealthPolicy?.proposalNumber.length > 0 ,
          onKeyDown: (evt) => {
            if (evt?.key === ' ') {
              evt.preventDefault();
            }
          },
        },
        {
          type: 'select',
          label: <div>EIA Required</div>,
          name: 'proposerDetails.eiaRequired',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          data: eiaRequired?.length > 0
              ? [
                  ...eiaRequired.map((eiaReq) => {
                    return {
                      label: eiaReq.value ? eiaReq.value : '',
                      value: eiaReq.code ? eiaReq.code : '',
                    };
                  }),
                ]
              : [
                  {
                    label: 'Yes',
                    value: 'Yes',
                  },
                  {
                    label: 'No',
                    value: 'No',
                  },
                  {
                    label: 'Already exist',
                    value: 'Already exist',
                  },
                ],
          onDataChange: (val, setFieldValue) => {
            if (
              val?.toLowerCase() === 'yes' ||
              val?.toLowerCase() === 'no'
            ) {
              setFieldValue(`proposerDetails.eiaNumber`, '');
            }
          },
        },
        {
          type: 'text',
          label: <div>EIA Number</div>,
          maxLength: 15,
          name: 'proposerDetails.eiaNumber',
          //disabled: reactiveVarData?.proposalNumber.length > 0,
          // disabled: buyHealthPolicy?.proposalNumber.length > 0 || ( buyHealthPolicy?.proposerDetails?.id !== null &&  buyHealthPolicy?.proposerDetails?.id.length>0 ),
          disabled:
            values.proposerDetails?.eiaRequired?.toLowerCase() ===
              'no' ||
            values.proposerDetails?.eiaRequired?.toLowerCase() ===
              'yes' ||
              buyHealthPolicy?.proposalNumber.length > 0 ,
          onKeyDown: (evt) => {
            if (
              evt?.target?.value?.toString()?.length === 0 &&
              evt?.key === ' '
            ) {
              evt.preventDefault();
            }
          },
        },
        /*EADivya - CR P2_233 KYC*/
      ],
    },
    /*SU Divya : CR P2_233 KYC :Hide Identification Details*/
    // {
    //   title: (
    //     <span className="text-primary">Identification Details</span>
    //   ),
    //   grid_type: 'input',
    //   grid_data: [
    //     {
    //       type: 'select',
    //       label: (
    //         <div>
    //           ID Proof Type <Text severity="error"></Text>
    //         </div>
    //       ),
    //       name: 'proposerDetails.idProofType',
    //       disabled: buyHealthPolicy?.proposalNumber.length > 0,
    //       data: idProofTypeList
    //         ? [
    //             ...idProofTypeList.map((idProofType) => {
    //               return {
    //                 label: idProofType.value ? idProofType.value : '',
    //                 value: idProofType.code ? idProofType.code : '',
    //               };
    //             }),
    //           ]
    //         : [],
    //     },
    //     {
    //       type: 'text',
    //       label: (
    //         <div>
    //           ID Proof Number <Text severity="error"></Text>
    //         </div>
    //       ),
    //       name: 'proposerDetails.idProofNumber',
    //       className: 'uppercase',
    //       disabled: buyHealthPolicy?.proposalNumber.length > 0,
    //     },
    //   ],
    // },
    /*EU Divya : CR P2_233 KYC: Hide Identification Details*/
    {
      title: <span className="text-primary">Internal Employee</span>,
      grid_type: 'input',
      grid_data: [
        {
          type: 'text',
          label: (
            <div>
              If the customer also an internal employee or staff of
              us, then provide the employee number{' '}
              <Text severity="error">
                {buyHealthPolicy?.quoteData?.isExistingEmployee?.toLowerCase() ===
                'yes'
                  ? '*'
                  : ''}
              </Text>
            </div>
          ),
          name: 'proposerDetails.employeeNumber',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
      ],
    },
    {
      title: (
        <span className="text-primary">
          Tax Identification Details
        </span>
      ),
      grid_type: 'input',
      grid_data: [
       
        {
          type: 'text',
          label: (
            <div>
              GST Number <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.gstNumber',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          className: 'uppercase',
        },
        {},
        {},
        {
          type: 'radiogroup',
          label: (
            <Text>
              Do you have PAN No ? <Text severity="error">*</Text>
            </Text>
          ),
          //  className:'flex',
          className: 'items-baseline space-x-2 mt-4',
          flow: 'row',
          name: 'proposerDetails.isPanAvailable',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
          data: [
            {
              label: 'Yes',
              value: 'Yes',
            },
            {
              label: 'No',
              value: 'No',
            },
          ],
          onRadioChange: (val) => {
            if (val === 'No') {
              setFieldValue(`proposerDetails.panNumber`, '')
            } else if (val === 'Yes') {
              setFieldValue(`proposerDetails.form60`, false)
            }
          },
        },
        values?.proposerDetails.isPanAvailable?.toString()?.toLowerCase() === 'yes'
          ? {
            type: 'text',
            label: (
              <div>
                PAN Card Number <Text severity="error">*</Text>
              </div>
            ),
            name: 'proposerDetails.panNumber',
            className: 'uppercase',
            disabled: buyHealthPolicy?.proposalNumber.length > 0,
          } : null,
        values?.proposerDetails.isPanAvailable?.toString()?.toLowerCase() === 'no'
          ? {
            type: 'checkbox',
            label: (
              <div>
                Form 60 <Text severity="error">*</Text>
              </div>
            ),
            name: 'proposerDetails.form60',
            className: 'mt-4',
            disabled: buyHealthPolicy?.proposalNumber.length > 0,
          } : null,
      ]?.filter(d => d),
    },
    {
      title: (
        <span className="text-primary">
          Permanent Address Details
        </span>
      ),
      grid_type: 'input',
      grid_data: [
        {
          type: 'text',
          label: (
            <div>
              Address Line 1 <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permAddressLine1',
          disabled: buyHealthPolicy?.proposalNumber.length > 0
            || buyHealthPolicy?.proposerDetails?.id?.length > 0 , //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commAddressLine1', val);
            }
          },
        },
        {
          type: 'text',
          label: (
            <div>
              Address Line 2 <Text severity="error"></Text>
            </div>
          ),
          name: 'proposerDetails.permAddressLine2',
          disabled: buyHealthPolicy?.proposalNumber.length > 0
            || buyHealthPolicy?.proposerDetails?.id?.length > 0 , //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commAddressLine2', val);
            }
          },
        },
        {
          type: 'text',
          label: (
            <div>
              Address Line 3 <Text></Text>
            </div>
          ),
          name: 'proposerDetails.permAddressLine3',
          disabled: buyHealthPolicy?.proposalNumber.length > 0
            || buyHealthPolicy?.proposerDetails?.id?.length > 0 , //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commAddressLine3', val);
            }
          },
        },
        {
          type: 'text',
          label: (
            <div>
              Landmark <Text></Text>
            </div>
          ),
          name: 'proposerDetails.permLandmark',
          disabled: buyHealthPolicy?.proposalNumber.length > 0
            || buyHealthPolicy?.proposerDetails?.id?.length > 0 , //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commLandmark', val);
            }
          },
        },
        {
          type: 'input-lookup',
          size: 'large',
          loading: loadingPermCustAddr,
          onLookup: onPermAddrLookup,
          label: (
            <div>
              Pin Code <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permPincode',
          disabled:
            loadingPermCustAddr ||
            buyHealthPolicy?.proposalNumber.length > 0
            ||  buyHealthPolicy?.proposerDetails?.id?.length > 0 , //SADivya : Cr P2_233:KYC
          onDataChange: (val, setFieldValue) => {
            setFieldValue('proposerDetails.permCityTownVillage', '');
            setFieldValue('proposerDetails.permState', '');
            setFieldValue('proposerDetails.permDistrict', '');
            if (values.proposerDetails.permCommAddressYN) {
              setFieldValue('proposerDetails.commPincode', val);
              setFieldValue(
                'proposerDetails.commCityTownVillage',
                '',
              );
              setFieldValue('proposerDetails.commState', '');
              setFieldValue('proposerDetails.commDistrict', '');
            }
          },
        },
        {
          type: 'text',
          label: (
            <div>
              City/Town/Village <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permCityTownVillage',
          disabled: true,
        },
        {
          type: 'text',
          label: (
            <div>
              District <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permDistrict',
          disabled: true,
        },
        {
          type: 'text',
          label: (
            <div>
              State <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.permState',
          disabled: true,
        },
      ],
    },
    {
      title: (
        <span className="text-primary">Communication Address</span>
      ),
      grid_data: values.proposerDetails.permCommAddressYN
        ? [
            {
              type: 'checkbox',
              name: 'proposerDetails.permCommAddressYN',
              disabled:
                loadingPermCustAddr ||
                loadingCommCustAddr ||
                buyHealthPolicy?.proposalNumber.length > 0,
              label:
                'Communication address same as permanent address',
              colSpan: repeat,
            onDataChange: (_, setFieldValue) => {
              setFieldValue(
                'proposerDetails.commAddressLine1',
                '',
              );
              setFieldValue(
                'proposerDetails.commAddressLine2',
                '',
              );
              setFieldValue(
                'proposerDetails.commAddressLine3',
                '',
              );
              setFieldValue('proposerDetails.commLandmark', '');
              setFieldValue('proposerDetails.commPincode', '');
              setFieldValue(
                'proposerDetails.commCityTownVillage',
                '',
              );
              setFieldValue('proposerDetails.commDistrict', '');
              setFieldValue('proposerDetails.commState', '');
            },
          },
          ]
        : [
            {
              type: 'checkbox',
              name: 'proposerDetails.permCommAddressYN',
              label:
                'Communication address same as permanent address',
              disabled:
                loadingPermCustAddr ||
                loadingCommCustAddr ||
                buyHealthPolicy?.proposalNumber.length > 0,
              colSpan: repeat,
              onDataChange: (_, setFieldValue) => {
                setFieldValue(
                  'proposerDetails.commAddressLine1',
                  values.proposerDetails.permAddressLine1,
                );
                setFieldValue(
                  'proposerDetails.commAddressLine2',
                  values.proposerDetails.permAddressLine2,
                );
                setFieldValue(
                  'proposerDetails.commAddressLine3',
                  values.proposerDetails.permAddressLine3,
                );
                setFieldValue(
                  'proposerDetails.commLandmark',
                  values.proposerDetails.permLandmark,
                );
                setFieldValue(
                  'proposerDetails.commPincode',
                  values.proposerDetails.permPincode,
                );
                setFieldValue(
                  'proposerDetails.commCityTownVillage',
                  values.proposerDetails.permCityTownVillage,
                );
                setFieldValue(
                  'proposerDetails.commDistrict',
                  values.proposerDetails.permDistrict,
                );
                setFieldValue(
                  'proposerDetails.commState',
                  values.proposerDetails.permState,
                );
              },
            },
            {
              type: 'text',
              label: (
                <div>
                  Address Line 1 <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commAddressLine1',
              disabled: buyHealthPolicy?.proposalNumber.length > 0,
            },
            {
              type: 'text',
              label: (
                <div>
                  Address Line 2 <Text severity="error"></Text>
                </div>
              ),
              name: 'proposerDetails.commAddressLine2',
              disabled: buyHealthPolicy?.proposalNumber.length > 0,
            },
            {
              type: 'text',
              label: (
                <div>
                  Address Line 3 <Text></Text>
                </div>
              ),
              name: 'proposerDetails.commAddressLine3',
              disabled: buyHealthPolicy?.proposalNumber.length > 0,
            },
            {
              type: 'text',
              label: (
                <div>
                  Landmark <Text></Text>
                </div>
              ),
              name: 'proposerDetails.commLandmark',
              disabled: buyHealthPolicy?.proposalNumber.length > 0,
            },
            {
              type: 'input-lookup',
              size: 'large',
              loading: loadingCommCustAddr,
              onLookup: onCommAddrLookup,
              label: (
                <div>
                  Pin Code <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commPincode',
              disabled:
                loadingCommCustAddr ||
                buyHealthPolicy?.proposalNumber.length > 0,
              onDataChange: (_, setFieldValue) => {
                setFieldValue(
                  'proposerDetails.commCityTownVillage',
                  '',
                );
                setFieldValue('proposerDetails.commState', '');
                setFieldValue('proposerDetails.commDistrict', '');
              },
            },
            {
              type: 'text',
              label: (
                <div>
                  City/Town/Village <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commCityTownVillage',
              disabled: true,
            },
            {
              type: 'text',
              label: (
                <div>
                  District <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commDistrict',
              disabled: true,
            },
            {
              type: 'text',
              label: (
                <div>
                  State <Text severity="error">*</Text>
                </div>
              ),
              name: 'proposerDetails.commState',
              disabled: true,
            },
          ],
    },
    {
      title: <span className="text-primary">Contact Details</span>,
      grid_data: [
        {
          type: 'text',
          maxLength: 10,
          onKeyDown: (evt) => evt.key === 'e' && evt.preventDefault(),
          label: (
            <div>
              Mobile Number <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.mobileNo',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
        {
          type: 'email',
          label: (
            <div>
              Email Id <Text severity="error">*</Text>
            </div>
          ),
          name: 'proposerDetails.emailID',
          disabled: buyHealthPolicy?.proposalNumber.length > 0,
        },
      ],
    },
  ].filter((d) => d !== null);

  const other_props = {
    flow: 'cols',
    repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    textType: 'normal',
    nullData: () => <Text severity="neutral">Not Captured</Text>,
  };

  return (
    <>
      <QuantaForm>
        <MixedGridGroup {...{ data, ...other_props }} />
      </QuantaForm>
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </>
  );
}
